import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

import ls from './ls';
import api from './api';

import { AUTH_STORAGE_NAME } from './consts';

import cart from './store/modules/cart';
import delivery from './store/modules/delivery';
import event from './store/modules/event';
import customer from './store/modules/customer';
import feePayments from './store/modules/feePayments';
import billing from './store/modules/billing';
import categories from './store/modules/categories';
import clientProfile from './store/modules/clientProfile';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    cart,
    delivery,
    customer,
    event,
    feePayments,
    billing,
    categories,
    clientProfile,
  },
  state: {
    auth: {},
    loadingJoinnus: false,
    access: [],
    userIsExclusivePoint: false,
    isValidPostData: false,
    existBrand: ls.getItem('brand') || 'izipay',
    openModalPos: false,
  },
  mutations: {
    login(state, data) {
      Vue.set(state, 'auth', data);
      Vue.set(state, 'authAccess', []);
      api.token = data.token;
      api.userAuth = data.user;
      axios.defaults.headers.common.Authorization = `Bearer ${data.token}`;
      ls.setItem(AUTH_STORAGE_NAME, JSON.stringify(data));
      const roleAgency = data && data.roles? data.roles.find((r) => r.name === 'agency') : {};
      if( roleAgency && roleAgency.details ) {
        const detailsParse = JSON.parse(roleAgency.details);
        if(detailsParse.access) {
          Vue.set(state, 'authAccess', detailsParse.access);
        }
        if(detailsParse.exclusivePoint) {
          Vue.set(state, 'userIsExclusivePoint', true);
        }
      }
    },
    logout(state) {
      Vue.set(state, 'auth', {});
      Vue.set(state, 'authAccess', []);
      Vue.set(state, 'userIsExclusivePoint', false);
      const timerExpire = localStorage.getItem('timerExpireSession');
      if( timerExpire ) {
        window.clearInterval(parseInt(timerExpire));
        localStorage.clear();
      }
    },
    CHANGE_LOADING_JOINNUS(state, payload) {
      state.loadingJoinnus = payload;
    },
    loginMessage(state, data) {
        Vue.set(state, 'loginMessage', data);
    },
    posData(state, data){
      Vue.set(state, 'isValidPostData', data);
    },
    existBrand(state, data){
      Vue.set(state, 'existBrand', data);
    },
    openModalPos(state) {
      Vue.set(state, 'openModalPos', true);
    },
  },
  actions: {
    login({ commit }, data) {
      const { payload, captcha } = data;
      const headers = {
        captcha,
      }
      // eslint-disable-next-line no-async-promise-executor
      return new Promise(async (resolve, reject) => {
        try {
          const res = await api.login(payload, headers);
          if (res.status) {
            resolve(res);
          } else {
            commit('loginMessage', res.message);
            resolve();
          }
        } catch (err) {
          reject(err);
        }
      });
    },
    setPosData({ commit }, data) {
      commit('posData', data);
    },
    setBrandSelected({ commit }, data) {
      ls.setItem('brand', data);
      commit('existBrand', data);
    },
    logout({ commit }) {
      return new Promise((resolve) => {
        commit('logout');
        api.token = null;
        api.userAuth = null;
        delete axios.defaults.headers.common.Authorization;
        ls.removeItem(AUTH_STORAGE_NAME);
        resolve();
      });
    },
    changeLoadingJoinnus({ commit }, payload) {
      commit('CHANGE_LOADING_JOINNUS', payload);
    },
    openModalPos({commit}) {
      commit('openModalPos');
    }
  },
  getters: {
    getloadingJoinnus(state) {
      return state.loadingJoinnus;
    },
    getLoginMessage(state) {
      return state.loginMessage;
    },
    getValidPostData(state) {
      return state.isValidPostData;
    },
    getBrandSelected(state) {
      return state.existBrand;
    },
  },
});
